<template>
	<div class="l-container">
		<div class="presentation-view">
			<div class="view-title">
				<div>
					<strong class="category">{{ ptInfo.ViewCategory }}</strong>
					<div v-html="ptInfo.ViewTitle"></div>
				</div>
			</div>
			<div class="view-detail">
				<img :src="ptInfo.ViewImg" :alt="ptInfo.ViewImgAlt" />
			</div>
		</div>
		<presentation-move></presentation-move>
	</div>
</template>

<script>
import ErrorPage from "@/components/Error";
import { store } from "../data/store.js";
import ptMove from "@/components/ptMove.vue";
export default {
	data() {
		return {
			store,
		};
	},
	components: {
		"presentation-move": ptMove,
	},
	computed: {
		ptInfo() {
			let k;
			let bsdList = this.store.bsd;
			const ptName = this.$route.params.id;
			for (k in bsdList) {
				if (bsdList[k].ptUrl == ptName) {
					return bsdList[k];
				}
			}
		},
	},
	created() {
		console.log("PresentationDetail");
	},
};
</script>

<style scoped>
.presentation-view {
	min-height: calc(100vh - 296px);
}
.view-title {
	background-color: #222;
	color: #fff;
}
.view-title > div {
	max-width: 1280px;
	margin: 0 auto;
	padding: 30px 20px;
	color: #fff;
	font-size: 2.4rem;
	line-height: 1.33;
	word-break: keep-all;
}

.view-title .category {
	display: inline-block;
	min-height: 32px;
	line-height: 1;
	margin-bottom: 20px;
	padding: 6px 16px 0 16px;
	border-radius: 16px;
	background-color: #eb2910;
	font-size: 1.6rem;
	font-weight: normal;
}

@media screen and (min-width: 1280px) {
	.view-detail {
		max-width: 1280px;
		margin: 80px auto 0 auto;
		text-align: center;
	}
	.view-title > div {
		min-height: 360px;
		padding-top: 60px;
		font-size: 6rem;
	}
	.view-title > div:after {
		content: "";
		display: block;
		clear: both;
	}
	.view-title .category {
		float: left;
		min-height: 40px;
		padding-top: 8px;
		font-size: 2rem;
		border-radius: 20px;
	}
	.view-title .category + div {
		float: left;
		width: 100%;
	}
}
</style>




// WEBPACK FOOTER //
// src/components/PresentationDetail.vue